import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchClassStudents(
  schoolClassId: number,
): Promise<Components.Schemas.StudentWithSubjectAccessDto[]> {
  const result = await Api.Routes.Student.retrieveStudentsOfClass({ schoolClassId });
  return result.rows;
}

export async function fetchSchoolStudents(): Promise<Components.Schemas.StudentDto[]> {
  const result = await Api.Routes.Student.retrieve({ $filter: { filter: [] } });
  return result.rows;
}

export async function fetchStudent(studentId: number): Promise<Components.Schemas.StudentDto> {
  const result = await Api.Routes.Student.retrieveOne({ id: studentId });
  return result.data;
}

export async function fetchSelectableStudentsForClass(params: {
  schoolClassId: number;
}): Promise<Components.Schemas.StudentDto[]> {
  const res = await Api.Routes.Student.retrieveSelectableStudentsOfClass(params);
  return res.rows;
}
